export default "__VITE_ASSET__fd73466c__"